import { useState } from "react";

// State and submit handling shared by the public forms. `status` is one of
// "idle", "submitting", "sent" or "failed".
export default function useFormPost(url, initialValues) {
  const [values, setValues] = useState(initialValues);
  const [status, setStatus] = useState("idle");

  // Editing after a successful send hides the thank-you, so it never sits
  // next to values that weren't the ones sent.
  function edit(update) {
    setValues(update);
    setStatus((current) => (current === "sent" ? "idle" : current));
  }

  function handleChange(event) {
    const { name, value } = event.target;
    edit((current) => ({ ...current, [name]: value }));
  }

  // Adds or removes `option` from the list stored under `field` (checkboxes).
  function toggle(field, option) {
    edit((current) => {
      const list = current[field];
      return {
        ...current,
        [field]: list.includes(option) ? list.filter((item) => item !== option) : [...list, option]
      };
    });
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setStatus("submitting");
    try {
      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(values)
      });
      if (!res.ok) throw new Error("Request failed");
      setStatus("sent");
    } catch (err) {
      setStatus("failed");
    }
  }

  return { values, status, handleChange, toggle, handleSubmit };
}
